import { Ass_03, Ass_10, Exp_03, Exp_05 } from "../../Chart.js";
import { Item } from "../../item/Item.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const TAXES: Template = {
  id: "ea6f0829-fd32-4dbb-bbf9-ee0f6dc14402",
  name: "Maksud EMTA-le (palk + dividendid)",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Date",
      type: "date"
    },
    {
      name: "Salary tax",
      type: "amount_eur"
    },
    {
      name: "Salary tax from credit",
      type: "amount_eur"
    },
    {
      name: "Dividends income tax",
      type: "amount_eur"
    }
  ],
  initialValues: [
    {
      name: "Title",
      value: "Maksud EMTA-le"
    },
    {
      name: "Salary tax",
      value: "549.30"
    },
    {
      name: "Salary tax from credit",
      value: "0.00"
    },
    {
      name: "Dividends income tax",
      value: "0.00"
    }
  ],
  generate: (values) => {
    const date = findVariableValue("Date", values);

    const salaryTax = Math.round(parseFloat(findVariableValue("Salary tax", values)) * 100);
    const salaryTaxCredit = Math.round(parseFloat(findVariableValue("Salary tax from credit", values)) * 100);
    const dividendsIncomeTax = Math.round(
      parseFloat(findVariableValue("Dividends income tax", values)) * 100
    );

    const items: Item[] = [
      {
        title: "Palga maksud",
        date: date,
        amount: salaryTax,
        eurAmount: salaryTax,
        currency: "eur",
        debit: Exp_03,
        credit: Ass_03
      }
    ];

    if (salaryTaxCredit !== 0) {
      items.push({
        title: "Ettemakse kasutamine palga maksudeks",
        date: date,
        amount: salaryTaxCredit,
        eurAmount: salaryTaxCredit,
        currency: "eur",
        debit: Exp_03,
        credit: Ass_10
      });
    }

    if (dividendsIncomeTax !== 0) {
      items.push({
        title: "Dividendi tulumaks",
        date: date,
        amount: dividendsIncomeTax,
        eurAmount: dividendsIncomeTax,
        currency: "eur",
        debit: Exp_05,
        credit: Ass_03
      });
    }

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: items
    };

    return { type: "success", entry };
  }
};
